const Experience = () => {
    return (
        <div className="experience">
            <h2>Experience</h2>

            <ul>
                <li>
                    <i>Baruch College</i>, <strong>Master Degree</strong>, New York, 2014-2016
                    <ul>
                        <li>Marketing</li>
                        <li>Self-learning Computer Science</li>
                        <li>Work in Shop.com and win President's challenge(Top Sales)</li>
                    </ul>
                </li>
                <li>
                    <i>Ambit Energy</i> - <strong>Excutive Consultant</strong>, 2016-2019
                    <ul>
                        <li>Top Sale in US, Japan and Canada</li>
                        <li>Design Training System and build team of more than 1000 people from scratch</li>
                    </ul>
                </li>
                <li>
                    <i>Tesla</i> - <strong>Product Specialist</strong>, 2019-2020
                    <ul>
                        <li>Top Sale in ShenZhen</li>
                        <li>Training Teacher in Tesla</li>
                    </ul>
                </li>
                <li>
                    <i>Vistra Energy</i> - <strong>Blockchain Developer</strong>, 2021-2023
                    <ul>
                        <li>Build NFT Dapps And Auditing</li>
                        <li>Make Web3 Training Videos and Write Training Articles</li>
                    </ul>
                </li>
                <li>
                    <i>HackQuest</i> - <strong>Blockchain Content Producer Lead</strong>, 2024
                    <ul>
                        <li>Making Blockchain Development Courses</li>
                        <li>Produce 10+ series of courses, cooperating with classic public chain such as Arbitrum, Solana and Sui</li>
                    </ul>
                </li>
            </ul>
        </div>
    );
}

export default Experience;